import React, {FunctionComponent, useEffect, useState} from 'react';
import closeIcon from "../../assets/icons/times-solid.svg";
import leftArrowIcon from "../../assets/icons/chevron-left-light.svg";
import {FilePreview} from "../FilePreview/FilePreview";
import {File} from "../../models/file.model";
import rightArrowIcon from "../../assets/icons/chevron-right-light.svg";
import {Button} from "../ui-components/Button/Button";
import {OverlayModal} from "../Modal/OverlayModal";
import './FilePreviewModal.scss';

interface FilePreviewModalProps {
    files: File[];
    currentFileIndex: number;
    onCloseModal: () => void;
    shouldDisplayFileName?: boolean;
}

export const FilePreviewModal: FunctionComponent<FilePreviewModalProps> = (props) => {
    const [currentFileInPreviewIndex, setCurrentFileInPreviewIndex] = useState<number | null>(props.currentFileIndex);
    const {files} = props;
    const shouldDisplayFileName = props.shouldDisplayFileName === undefined ? true : props.shouldDisplayFileName;

    useEffect(() => {
        window.addEventListener('keydown', onArrowKeyDown);
        window.addEventListener('keydown', onArrowKeyDown);

        return () => {
            window.removeEventListener('keydown', onArrowKeyDown);
            window.removeEventListener('keydown', onArrowKeyDown);
        };
    }, [currentFileInPreviewIndex]);

    const onArrowKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'ArrowRight') {
            nextFilePreview();
        }

        if (e.key === 'ArrowLeft') {
            previousFilePreview();
        }
    };

    const nextFilePreview = () => {
        if (currentFileInPreviewIndex !== null) {
            if (currentFileInPreviewIndex === files.length - 1) {
                setCurrentFileInPreviewIndex(0);
            } else {
                setCurrentFileInPreviewIndex(currentFileInPreviewIndex + 1);
            }
        }
    };

    const previousFilePreview = () => {
        if (currentFileInPreviewIndex !== null) {
            if (currentFileInPreviewIndex === 0) {
                setCurrentFileInPreviewIndex(files.length - 1);
            } else {
                setCurrentFileInPreviewIndex(currentFileInPreviewIndex - 1);
            }
        }
    };

    const closeModal = () => {
        props.onCloseModal();
    };

    return (
        <OverlayModal onCloseModal={props.onCloseModal}>
            <header>
                <h1 className='truncate'>{shouldDisplayFileName ? files[currentFileInPreviewIndex as number]?.display_name : ''}</h1>
                <img onClick={closeModal} className='image-icon desktop-2x clickable' src={closeIcon} alt="close"/>
            </header>
            <main className='file-preview-main'>
                <div className='change-preview-button-container' onClick={previousFilePreview}>
                    <img className='change-file-icon' src={leftArrowIcon} alt="Previous File"/>
                </div>

                <FilePreview file={files[currentFileInPreviewIndex as number] as File}/>

                <div className='change-preview-button-container' onClick={nextFilePreview}>
                    <img className='change-file-icon' src={rightArrowIcon} alt="Next File"/>
                </div>
            </main>
            <footer>
                <Button className='white-button' onClick={closeModal}>Close</Button>

                <a href={files[currentFileInPreviewIndex as number]?.url} download target='_blank'>
                    <Button>Download</Button>
                </a>
            </footer>
        </OverlayModal>
    );
};
